module.exports = __webpack_public_path__ + "static/media/logo_cimb.b9b9e586.svg";